import { observable, action, runInAction } from 'mobx';

import { WarriorType } from '../lib/types';

import { getBotsOnIsland, getOnlineWarriors } from '../lib/dbCalls';
import { inBuilding } from '../utils/warriorUtils';

import heroStore from './hero';
import appStore from './app';

class Island {
  @observable
  warriors: WarriorType[] = [];

  @observable
  warriorsFetching: boolean = false;

  @action
  async fetch(
    x: number = heroStore.hero.location.coordinateX,
    y: number = heroStore.hero.location.coordinateY,
    force?: boolean,
  ) {
    if (this.warriorsFetching && !force) return;
    this.warriorsFetching = true;
    const [warriors, bots] = await Promise.all([
      getOnlineWarriors(appStore.initData, heroStore.hero.location.island),
      getBotsOnIsland(heroStore.hero.location.island, x, y),
    ]);
    runInAction(() => {
      const warriorsOnIsland = warriors.filter((warrior) => !inBuilding(warrior));

      (this.warriors as any).replace(warriorsOnIsland.concat(bots));
      this.warriorsFetching = false;

      heroStore.checkCombatBotsTime();
    });
  }
}

export default new Island();
